import { createActions } from "reduxsauce";

export default createActions(
  {
    signUp: ["values"],
    getSsnKey: ["values", "setLoader", "setQrCodes", "setToken"],
    signUpFacebook: null,
    emailConfirmed: ["values"],
    passwordCreated: ["values"],
    resendEmailCode: null,
    setLoginMethod: ["method"]
  },
  { prefix: "auth/" }
);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-actions.js